/*
  Fizzy Moo Weird-o-meter. Moves the slider, and the cow answers back.
*/
(function () {
  function init(root) {
    if (!root || root.dataset.fmReady === 'true') return;
    var range = root.querySelector('[data-fm-weird-range]');
    var title = root.querySelector('[data-fm-weird-title]');
    var text = root.querySelector('[data-fm-weird-text]');
    var dataEl = root.querySelector('[data-fm-weird-answers]');
    if (!range || !title || !text || !dataEl) return;
    var answers;
    try {
      answers = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }
    root.dataset.fmReady = 'true';

    function update() {
      var value = Number(range.value);
      var answer = answers[answers.length - 1];
      for (var i = 0; i < answers.length; i++) {
        if (value <= answers[i].max) {
          answer = answers[i];
          break;
        }
      }
      title.textContent = answer.title;
      text.textContent = answer.text;
      range.style.setProperty('--fm-fill', value + '%');
    }

    range.addEventListener('input', update);
    range.addEventListener('change', update);
    update();
  }

  function initAll() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-fm-weird]'), init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-fm-weird]');
    if (root) init(root);
  });
})();
